<script lang="ts">
	import type { HistoryPoint } from "./HistoryPoint.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./History.translations.json";
	import HistoryCard from "./HistoryCard.svelte";
	import history1862 from "../assets/history/1862.jpeg?webp&h=350&imagetools";
	import history1927 from "../assets/history/1927.png?webp&h=350&imagetools";
	import history1948 from "../assets/history/1948.jpeg?webp&h=350&imagetools";
	import history1972 from "../assets/history/1972.png?webp&h=350&imagetools";
	import history1992 from "../assets/history/1992.png?webp&h=350&imagetools";
	import history19991 from "../assets/history/1999-1.png?webp&h=350&imagetools";
	import history19992 from "../assets/history/1999-2.png?webp&h=350&imagetools";
	import history19993 from "../assets/history/1999-3.png?webp&h=350&imagetools";
	import history2006 from "../assets/history/2006.png?webp&h=350&imagetools";
	import history2007 from "../assets/history/2007.png?webp&h=350&imagetools";
	import history20101 from "../assets/history/2010-1.png?webp&h=350&imagetools";
	import history20102 from "../assets/history/2010-2.png?webp&h=350&imagetools";
	import history2014 from "../assets/history/2014.png?webp&h=350&imagetools";
	import history2016 from "../assets/history/2016.png?webp&h=350&imagetools";
	import history2018 from "../assets/history/2018.png?webp&h=350&imagetools";
	import history2020 from "../assets/history/2020.jpeg?webp&h=350&imagetools";
	import history2022 from "../assets/history/2022.png?webp&h=350&imagetools";
	import history2024 from "../assets/history/2024.png?webp&h=350&imagetools";
	import Button from "./Button.svelte";

	const translate = getTranslate(translations);

	const historyPoints: HistoryPoint[] = [
		{
			headline: translate("point1Headline"),
			perex: translate("point1Perex"),
			year: 1862,
			image: history1862,
		},
		{
			headline: translate("point2Headline"),
			perex: translate("point2Perex"),
			year: 1927,
			image: history1927,
		},
		{
			headline: translate("point3Headline"),
			perex: translate("point3Perex"),
			year: 1948,
			image: history1948,
		},
		{
			headline: translate("point4Headline"),
			perex: translate("point4Perex"),
			year: 1972,
			image: history1972,
		},
		{
			headline: translate("point5Headline"),
			perex: translate("point5Perex"),
			year: 1992,
			image: history1992,
		},
		{
			headline: translate("point6Headline"),
			perex: translate("point6Perex"),
			year: 1999,
			image: history19991,
		},
		{
			headline: translate("point7Headline"),
			perex: translate("point7Perex"),
			year: 1999,
			image: history19992,
		},
		{
			headline: translate("point8Headline"),
			perex: translate("point8Perex"),
			year: 1999,
			image: history19993,
		},
		{
			headline: translate("point9Headline"),
			perex: translate("point9Perex"),
			year: 2006,
			image: history2006,
		},
		{
			headline: translate("point10Headline"),
			perex: translate("point10Perex"),
			year: 2007,
			image: history2007,
		},
		{
			headline: translate("point11Headline"),
			perex: translate("point11Perex"),
			year: 2010,
			image: history20101,
		},
		{
			headline: translate("point12Headline"),
			perex: translate("point12Perex"),
			year: 2010,
			image: history20102,
		},
		{
			headline: translate("point13Headline"),
			perex: translate("point13Perex"),
			year: 2014,
			image: history2014,
		},
		{
			headline: translate("point14Headline"),
			perex: translate("point14Perex"),
			year: 2016,
			image: history2016,
		},
		{
			headline: translate("point15Headline"),
			perex: translate("point15Perex"),
			year: 2018,
			image: history2018,
		},
		{
			headline: translate("point16Headline"),
			perex: translate("point16Perex"),
			year: 2020,
			image: history2020,
		},
		{
			headline: translate("point17Headline"),
			perex: translate("point17Perex"),
			year: 2022,
			image: history2022,
		},
		{
			headline: translate("point18Headline"),
			perex: translate("point18Perex"),
			year: 2024,
			image: history2024,
		},
	];

	let showMore = false;
	const maxShow = 6;
</script>

<div class="flex flex-col">
	<h2 class="m-0 mb-12 text-[2.75rem] lg:text-4xl">{translate("heading")}</h2>
	<div class="grid grid-cols-1 grid-rows-[auto,auto] gap-y-32 lg:grid-cols-[33.75rem,1fr] lg:grid-rows-1 lg:gap-y-0">
		{#each historyPoints.slice(0, showMore ? undefined : maxShow) as point}
			<HistoryCard {point} />
		{/each}
	</div>

	{#if !showMore}
		<div class="mt-16 flex justify-stretch lg:mt-36 lg:justify-end">
			<Button
				class="max-lg:!w-full max-lg:!max-w-full"
				on:click={() => {
					showMore = true;
				}}
			>
				{translate("exploreMore")}
			</Button>
		</div>
	{/if}
</div>
